jQuery_T4NT(document).ready(function ($) {
  $(document).on("mouseover", ".custom-product-grid-item1", function () {
    const current_color = $(this).attr("data-color-active");
    $(this)
      .siblings()
      .each(function () {
        $(this).removeClass("custom-product-grid-item1-active");
      });
    $(this).addClass("custom-product-grid-item1-active");

    let featured_image;
    let current_variant;
    $.each(
      JSON.parse($(this).attr("data-img-current_variant")),
      function (index, item) {
        if (item.option1 == current_color) {
          featured_image = item["featured_image"];
          current_variant = item.id;
          return false;
        }
      }
    );
    var $product = $(this).closest(".t4s-product-wrapper");
    var $mainImg = $product.find(".t4s-product-main-img");
    var $prLink = $product.find(".t4s-full-width-link");
    if ($mainImg.length) {
      $mainImg.attr("src", featured_image.src);
      $mainImg.attr("srcset", featured_image.src);
    } else {
      console.log("未找到主图");
    }
    $prLink.attr(
      "href",
      $(this).attr("data-pr-href") + "?variant=" + current_variant
    );
  });

  /**
   *  Variant selection changed
   *  data-variant-toggle="{{variant.id}}"
   */
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });
});
